import { render, staticRenderFns } from "./DataSeedSettings.vue?vue&type=template&id=265414fe&scoped=true&"
import script from "./DataSeedSettings.vue?vue&type=script&lang=js&"
export * from "./DataSeedSettings.vue?vue&type=script&lang=js&"
import style0 from "./DataSeedSettings.vue?vue&type=style&index=0&id=265414fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265414fe",
  null
  
)

export default component.exports